import { Box, useTheme } from '@mui/material';

export const MainBackground = () => {
  const theme = useTheme();

  return (
    <Box
      component="svg"
      aria-hidden="true"
      viewBox="0 0 1200 900"
      preserveAspectRatio="xMidYMin slice"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        display: 'block',
        width: '100vw',
        height: '100vh',
        maxWidth: 'none',
        pointerEvents: 'none',
      }}
    >
      <defs>
        <linearGradient id="platform-background" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={theme.palette.background.paper} />
          <stop offset="0.55" stopColor={theme.palette.background.default} />
          <stop offset="1" stopColor={theme.palette.primary.light} stopOpacity="0.14" />
        </linearGradient>
      </defs>

      <rect width="1200" height="900" fill="url(#platform-background)" />
      <g fill="none" stroke={theme.palette.primary.main} strokeOpacity="0.09" strokeWidth="1.5">
        <path d="M78 236H272L354 318H574L670 222H880L984 326H1160" />
        <path d="M24 618H216L330 504H546L654 612H846L960 498H1198" />
      </g>

      <g fill={theme.palette.background.paper} stroke={theme.palette.primary.main} strokeOpacity="0.16" strokeWidth="1.5">
        <circle cx="78" cy="236" r="14" />
        <circle cx="272" cy="236" r="7" />
        <circle cx="574" cy="318" r="7" />
        <circle cx="880" cy="222" r="7" />
        <circle cx="216" cy="618" r="7" />
        <circle cx="546" cy="504" r="7" />
        <circle cx="846" cy="612" r="7" />
      </g>
    </Box>
  );
};
